import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';
import { CircleButton, CopyModule, YatFadeIn, YatSprite } from '@pkg/components';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { type EmojiId } from '@app/client/common/structs/emoji/emoji';
import config from '@app/config';
import { useLockBodyScroll } from '@app/helpers';
import { setMobileShareModalIsOpen } from '@app/store/actions/dashboard';

import './MobileShareModal.scss';

interface Props {
    yat?: EmojiId;
}

export const YatDashboardMobileShareModal = ({ yat }: Props) => {
    const dispatch = useAppDispatch();
    const { mobileShareModalIsOpen } = useAppSelector((state) => state.dashboard);
    const [modalAriaHidden, setModalAriaHidden] = useState(true); //setting to false before to prevent the flash on load (not sure if this works 100% tbh i feel like it still fades in a bit TODO? )
    const { t } = useTranslation(['dashboard', 'words']);
    const yatLink = `${config.publicUrl}/`;
    useLockBodyScroll(mobileShareModalIsOpen);

    const closeSidebar = () => {
        dispatch(setMobileShareModalIsOpen(false));
    };

    useEffect(() => {
        setModalAriaHidden(!mobileShareModalIsOpen);
    }, [mobileShareModalIsOpen]);

    if (yat == null) {
        return null;
    }

    return (
        <YatFadeIn appear={mobileShareModalIsOpen} classes="yat-dashboard-mobile-share-modal__outer">
            <nav
                id="yat-dashboard-mobile-share-modal"
                className="yat-dashboard-mobile-share-modal"
                aria-hidden={modalAriaHidden}
            >
                <div className="yat-dashboard-mobile-share-modal__top">
                    <strong className="yat-dashboard-mobile-share-modal__title">
                        {yatLink}
                        <YatSprite emojiID={yat} />
                    </strong>
                    <CircleButton
                        onClick={closeSidebar}
                        ariaLabel={t('close_menu')}
                        size="large"
                        classes="yat-dashboard-mobile-share-modal__close"
                    >
                        <CloseIcon aria-hidden="true" />
                    </CircleButton>
                </div>
                {/* eslint-disable-next-line react/jsx-no-undef */}
                <CopyModule emojiId={yat} variant={'secondary'} />
            </nav>
        </YatFadeIn>
    );
};
